export default __webpack_public_path__ + "static/media/kast-uus.52af4e56.jpg";